import { Injectable, inject } from '@angular/core';
import { get, post, put, patch, del } from 'aws-amplify/api';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public async get(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<any> {
    return (await get({ apiName, path, options }).response).body.json();
  }

  public async post(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = post({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error: unknown) {
      this.logger.error({ message: 'API post error', error: error as Error });
      throw error;
    }
  }

  public async put(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = put({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error: unknown) {
      this.logger.error({ message: 'API put error', error: error as Error });
      throw error;
    }
  }

  public async patch(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = patch({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error: unknown) {
      this.logger.error({ message: 'API patch error', error: error as Error });
      throw error;
    }
  }

  public async del(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<void> {
    await del({ apiName, path, options }).response;
  }

  private readonly logger = inject(LoggingService);
}
